import { Dialog, DialogContent, DialogTitle, Typography } from '@mui/material'
import TenantForm from '../component/form/TenantForm'
import PasswordResetForm from '../component/form/PasswordResetForm'

const PasswordRestModal = (props) =>{

  const close = () => {
    props.setOpen(false);
  }

  const submit = (data) =>{
    props.process(data);
    close();
  }

  return (
    <>
      <Dialog open={props.open} onClose={close} sx={{}}>
        <DialogTitle><Typography variant={'body'} >パスワードリセット</Typography></DialogTitle>
        <DialogContent>
          <PasswordResetForm process={submit} />
        </DialogContent>
      </Dialog>
    </>
  );
}
export default PasswordRestModal